
import { EXPENSE_TYPES } from '../_constants/constants'
const { validationMixin } = require('vuelidate')

const { requiredIf, minLength } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  computed: {
    officeValidationConfig () {
      return this.$store.getters['CompanyStore/officeFormConfigurations']
    },
    validationModel () {
      let type
      if (this.expenseType === EXPENSE_TYPES.EXPENSE || this.expenseType === EXPENSE_TYPES.TRANSACTION) {
        if (this.transactionId) {
          type = this.transaction.receipt?.type !== 'NONE' ? this.transaction.receipt?.type : 'RECEIPT'
        } else {
          type = 'RECEIPT'
        }
        return this.officeValidationConfig[this.expenseType][type]
      } else {
        return this.officeValidationConfig[this.expenseType]
      }
    }
  },
  methods: {
    fieldIsRequired (fieldName) {
      if (!fieldName) return
      if (this.validationModel && this.validationModel.configuration) {
        const fieldIsRequired = this.validationModel.configuration.find(el => el.field === fieldName)
        if (fieldIsRequired?.isMandatory) {
          return 'u-required'
        }
      }
      return ''
    },
    generateReceiptValidationModel () {
      const receiptModel = { receipt: {} }
      const { receipt } = receiptModel
      this.validationModel.configuration.forEach(el => {
        if (el.field === 'providerData') {
          receipt.providerData = {
            required: requiredIf(function () {
              return el.isMandatory
            })
          }
        }
        if (el.field === 'provider') {
          receipt.provider = {
            required: requiredIf(function () {
              return el.isMandatory
            })
          }
        }

        if (el.field === 'receiptNumber') {
          receipt.receiptNumber = {
            required: requiredIf(function () {
              return el.isMandatory
            })

          }
        }
        if (el.field === 'country') {
          receipt.country = {
            required: requiredIf(function () {
              return el.isMandatory
            })

          }
        }

        if (el.field === 'state') {
          receipt.state = {
            required: requiredIf(function () {
              return el.isMandatory
            })

          }
        }
        if (el.field === 'zipCode') {
          receipt.zipCode = {
            required: requiredIf(function () {
              return el.isMandatory
            })

          }
        }

        if (el.field === 'city') {
          receipt.city = {
            required: requiredIf(function () {
              return el.isMandatory
            })

          }
        }

        if (el.field === 'address') {
          receipt.address = {
            required: requiredIf(function () {
              return el.isMandatory
            })

          }
        }
      })

      return receiptModel
    },
    generateTransactionValidationModel () {
      const transactionValidationModel = {}

      this.validationModel.configuration.forEach(el => {
        if (el.field === 'notes') {
          transactionValidationModel.notes = {
            required: requiredIf(function () {
              return el.isMandatory
            })
          }
        }
      })
      return transactionValidationModel
    },
    generateExpenseValidationModel () {
      const expenseModel = {
        transaction: {}
      }

      const { transaction } = expenseModel

      this.validationModel.configuration.forEach(el => {
        if (el.field === 'amount') {
          transaction.amount = {
            required: requiredIf(function () {
              return el.isMandatory
            })
          }
        }

        if (el.field === 'paymentMethod') {
          transaction.paymentMethod = {}
          transaction.paymentMethod.id = {
            required: requiredIf(function () {
              return el.isMandatory
            })
          }
        }
        if (el.field === 'date') {
          transaction.date = {
            required: requiredIf(function () {
              return el.isMandatory
            })
          }
        }

        if (el.field === 'notes') {
          transaction.notes = {
            required: requiredIf(function () {
              return el.isMandatory
            })

          }
        }
      })

      return expenseModel
    },
    generateMileageValidationModel () {
      const mileageValidationModel = {
        mileage: {},
        paymentMethod: {},
        distance: {}
      }

      const { mileage } = mileageValidationModel

      this.validationModel.configuration.forEach(el => {
        if (el.field === 'mileageCategory') {
          mileage.category = {}
          mileage.category.id = {
            required: requiredIf(function () {
              return el.isMandatory
            })
          }
        }

        if (el.field === 'origin') {
          mileage.origin = {}
          mileage.origin.name = {
            required: requiredIf(function () {
              return el.isMandatory
            })

          }
        }

        if (el.field === 'destination') {
          mileage.destination = {}
          mileage.destination.name = {
            required: requiredIf(function () {
              return el.isMandatory
            })

          }
        }

        if (el.field === 'distance') {
          mileageValidationModel.distance = {
            required: requiredIf(function () {
              return el.isMandatory
            })
          }
        }

        if (el.field === 'roundTrip') {
          mileage.roundTrip = {
            required: requiredIf(function () {
              return el.isMandatory
            })
          }
        }
        if (el.field === 'date') {
          mileage.date = {
            required: requiredIf(function () {
              return el.isMandatory
            }),
            validDate: (value) => this.$moment.utc(value).isValid()
          }
        }
        if (el.field === 'paymentMethod') {
          mileageValidationModel.paymentMethod = {
            required: requiredIf(function () {
              return el.isMandatory
            })

          }
        }

        if (el.field === 'notes') {
          mileageValidationModel.notes = {
            required: requiredIf(function () {
              return el.isMandatory
            })
          }
        }
      })
      return mileageValidationModel
    },
    generateDietValidationModel () {
      const dietValidationModel = {
        dietSteps: {},
        paymentMethod: {},
        selectedDietCategories: [],
        diet: {}
      }

      this.validationModel.configuration.forEach(el => {
        if (el.field === 'paymentMethod') {
          dietValidationModel.paymentMethod = {
            required: requiredIf(function () {
              return el.isMandatory
            })

          }
        }

        if (el.field === 'dietSteps') {
          dietValidationModel.dietSteps = {
            required: requiredIf(function () {
              return el.isMandatory
            }),
            minLength: minLength(2),
            $each: {
              placeInfo: {
                name: {
                  required: requiredIf(function () {
                    return el.isMandatory
                  })

                }
              },

              date: {
                required: requiredIf(function () {
                  return el.isMandatory
                }),
                validDate: (value) => this.$moment.utc(value).isValid()

              }
            }
          }
        }

        if (el.field === 'dietCategoryConfigs') {
          dietValidationModel.selectedDietCategories = {
            required: requiredIf(function () {
              return el.isMandatory
            }),
            validConfig: () => {
              return this.selectedDietCategories.some(el => {
                return el.count > 0
              })
            }

          }
        }
        if (el.field === 'notes') {
          dietValidationModel.diet.notes = {
            required: requiredIf(function () {
              return el.isMandatory
            })

          }
        }
      })
      return dietValidationModel
    }

  },
  validations () {
    let validationObject = {}
    this.validationModel.configuration.forEach(el => {
      if (this.expenseType === EXPENSE_TYPES.EXPENSE || this.expenseType === EXPENSE_TYPES.TRANSACTION) {
        if (el.field === 'defaultCategory') {
          validationObject.selectedCategoryObject = {
            required: requiredIf(function () {
              return el.isMandatory
            })
          }
        }

        if (el.field === 'vatTypeAssigned') {
          validationObject.selectedVatRegion = {}
          validationObject.selectedVatRegion.id = {
            required: requiredIf(function () {
              return el.isMandatory
            })

          }
        }

        if (this.expenseType === EXPENSE_TYPES.EXPENSE) {
          validationObject = { ...validationObject, ...this.generateExpenseValidationModel() }
        }
        if (this.expenseType === EXPENSE_TYPES.TRANSACTION) {
          validationObject = { ...validationObject, ...this.generateTransactionValidationModel() }
        }

        validationObject = { ...validationObject, ...this.generateReceiptValidationModel() }
      }

      if (this.expenseType === EXPENSE_TYPES.MILEAGE) {
        validationObject = { ...validationObject, ...this.generateMileageValidationModel() }
      }

      if (this.expenseType === EXPENSE_TYPES.DIET) {
        validationObject = { ...validationObject, ...this.generateDietValidationModel() }
      }
      /* if (el.field === 'medias') {
        validationObject.receipts = {
          required: requiredIf(function () {
            return el.isMandatory
          })
        }
      } */

      if (el.field === 'budget') {
        validationObject.budget = {
          required: requiredIf(function () {
            return el.isMandatory
          })
        }
      }
    })
    return validationObject
  }

}
